import React, { Component } from "react";
import Table from "../table";
import Icon from "../icon";
import message from "../message";
import { fetch } from "@fishx/rest";
import PropTypes from "prop-types";
import isEqual from "lodash/isEqual";
import { TableProps } from "antd/lib/table";
import shortid from "shortid";
import Column from "antd/lib/table/Column";

interface ETProps extends TableProps<object> {
  insertable: boolean;
  removeable: boolean;
  upmoveable: boolean;
  downmoveable: boolean;
  operColumnTitle: any;
  onSaveRowEdit: Function;
  beforeRowDelete: Function;
  afterRowDelete: Function;
  afterUpMoveRow: Function;
  afterDownMoveRow: Function;
}

interface ETState {
  editingKey: string;
  newColumns: any[];
  dataSource: any[];
  columns: any[];
  update: boolean;
  removeable: boolean;
  upmoveable: boolean;
  downmoveable: boolean;
}

export default class TableEdit extends Component<ETProps, ETState> {
  static componentName = 'TableEdit';
  static Column = Column;
  static propTypes = {
    insertable: PropTypes.bool,
    removeable: PropTypes.bool,
    upmoveable: PropTypes.bool,
    downmoveable: PropTypes.bool,
    operateFirst: PropTypes.bool,
    onSaveRowEdit: PropTypes.func,
    beforeRowDelete: PropTypes.func,
    afterRowDelete: PropTypes.func,
    afterUpMoveRow: PropTypes.func,
    afterDownMoveRow: PropTypes.func,
  };
  static defaultProps = {
    insertable: false,
    removeable: false,
    upmoveable: false,
    update: false,
    downmoveable: false,
    operateFirst: false,
    operColumnTitle: 'Operation'
  };
  constructor(props) {
    super(props);
    const { dataSource, columns, removeable, upmoveable, downmoveable, operateFirst } = this.props;
    this.state = {
      editingKey: "",
      newColumns: [],
      columns,
      dataSource,
      removeable,
      upmoveable,
      update: false,
      downmoveable,
      operateFirst
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let changeObj: any = {};
    if (!isEqual(nextProps.dataSource, prevState.dataSource)) {
      if (nextProps.update === prevState.update) {
        changeObj.dataSource = nextProps.dataSource;
      } else {
        changeObj.update = false;
      }
    }
    if (!isEqual(nextProps.columns, prevState.columns)) {
      if (nextProps.update === prevState.update) {
        changeObj.columns = nextProps.columns;
      } else {
        changeObj.update = false;
      }
    }
    if (!isEqual(nextProps.removeable, prevState.removeable)) {
      if (nextProps.update === prevState.update) {
        changeObj.removeable = nextProps.removeable;
      } else {
        changeObj.update = false;
      }
    }
    if (!isEqual(nextProps.upmoveable, prevState.upmoveable)) {
      if (nextProps.update === prevState.update) {
        changeObj.upmoveable = nextProps.upmoveable;
      } else {
        changeObj.update = false;
      }
    }
    if (!isEqual(nextProps.downmoveable, prevState.downmoveable)) {
      if (nextProps.update === prevState.update) {
        changeObj.downmoveable = nextProps.downmoveable;
      } else {
        changeObj.update = false;
      }
    }
    return Object.keys(changeObj).length ? changeObj : null;
  }

  addRow = () => {
    const { dataSource, newColumns } = this.state;
    const { rowKey = "key" } = this.props;
    const key = shortid.generate();
    const newRow = { [rowKey as string]: key };
    newColumns.forEach((v) => {
      if (v.dataIndex !== "edit") {
        if (v.editType === "date") {
          newRow[v.dataIndex] = new Date().toLocaleDateString();
        } else {
          newRow[v.dataIndex] = "";
        }
      }
    });
    const newData = dataSource.concat(newRow);
    this.setState({ dataSource: newData, editingKey: key, update: true });
  };

  onSaveRowEdit = (reocrd, newData) => {
    const { onSaveRowEdit } = this.props;
    this.setState({ dataSource: newData, update: true });
    onSaveRowEdit && onSaveRowEdit(reocrd, newData);
  };

  delRow = (key) => {
    const { dataSource } = this.state;
    const { beforeRowDelete, afterRowDelete } = this.props;
    const record = dataSource.find((item) => item.key === key);
    if (beforeRowDelete && !beforeRowDelete(record)) {
      return;
    }
    const newData = dataSource.filter((item) => item.key !== key);
    this.setState({ dataSource: newData, update: true });
    afterRowDelete && afterRowDelete(newData);
  };

  upMoveRow = (key) => {
    const { dataSource, editingKey } = this.state;
    const { afterUpMoveRow } = this.props;
    const newData = [...dataSource];
    const idx = newData.findIndex((item) => item.key === key);
    if (idx !== 0) {
      newData[idx] = newData.splice(idx - 1, 1, newData[idx])[0];
      this.setState({ dataSource: newData, update: true });
      afterUpMoveRow && afterUpMoveRow(newData, newData[idx - 1], editingKey);
    } else {
      message.warn("当前行是第一行，无法上移");
    }
  };

  downMoveRow = (key) => {
    const { dataSource, editingKey } = this.state;
    const { afterDownMoveRow } = this.props;
    const newData = [...dataSource];
    const idx = newData.findIndex((item) => item.key === key);
    if (idx !== newData.length - 1) {
      newData[idx] = newData.splice(idx + 1, 1, newData[idx])[0];
      this.setState({ dataSource: newData, update: true });
      afterDownMoveRow && afterDownMoveRow(newData, newData[idx + 1], editingKey);
    } else {
      message.warn("当前行是最后一行，无法下移");
    }
  };

  caluNewColumns = async () => {
    const { children, operColumnTitle } = this.props;
    const { removeable, upmoveable, downmoveable, columns, operateFirst } = this.state;
    const editColumn = {
      title: operColumnTitle,
      dataIndex: "edit",
      // width: 100, // #160 最后一列不能设定宽度 会影响列头伸缩
      editable: true,
      render: (_, record) => {
        return (
          <React.Fragment>
            {removeable && (
              <a
                onClick={() => {
                  this.delRow(record.key);
                }}
              >
                <Icon type="delete" />
                &nbsp;&nbsp;
              </a>
            )}
            {upmoveable && (
              <a
                onClick={() => {
                  this.upMoveRow(record.key);
                }}
              >
                <Icon type="arrow-up" />
                &nbsp;&nbsp;
              </a>
            )}
            {downmoveable && (
              <a
                onClick={() => {
                  this.downMoveRow(record.key);
                }}
              >
                <Icon type="arrow-down" />
              </a>
            )}
          </React.Fragment>
        );
      },
      editContent: () => <Icon type="edit" />,
      saveContent: () => <Icon type="save" />,
      cancelContent: () => <Icon type="stop" />,
    };
    let _columns = [];
    if (columns) {
      for (let i = 0; i < columns.length; i++) {
        const col: any = columns[i];
        const { editOptions, editType } = col;
        if (editOptions && editOptions.indexOf("http") !== -1) {
          const { data } = await fetch(editOptions, { method: "GET" });
          col.editOptions = data;
        }
        if (col.editOptions && col.editOptions.length) {
          col.render = text => {
            if (editType === 'select') {
              let res = col.editOptions.find(v => v.value === text);
              return res ? res.label : null;
            } else if (editType === 'treeSelect') {
              return text && text.label ? text.label : text;
            } else if (editType === 'multiTreeSelect' && Array.isArray(text)) {
              const labels = text.map(v => v.label) || [];
              return labels;
            } else if (editType === 'checkbox' && Array.isArray(text)) {
              const filters = col.editOptions.filter(v => text.includes(v.value)).map(v => v.label) || [];
              return filters.length > 0 ? filters : text;
            } else {
              return text;
            }
          };
        }
      }
      if (operateFirst) {
        _columns = [editColumn, ...columns];
      } else {
        _columns = [...columns, editColumn];
      }
    } else {
      //处理JSX风格的表格写法，不含columns属性，通过Column组件实现列定义
      for (let i = 0; i < (children as Array<any>).length; i++) {
        const child = (children as Array<any>)[i];
        if (!child.props) {
          continue;
        }
        let {
          props: {
            title,
            dataIndex,
            width,
            editType,
            editOptions = [],
            editRules = [],
            ...restOpts
          },
        } = child;
        if (editOptions.indexOf("http") !== -1) {
          const { data } = await fetch(editOptions, { method: "GET" });
          editOptions = data;
        }
        let render;
        if (editOptions.length) {
          render = text => {
            if (editType === 'select') {
              let res = editOptions.find(v => v.value === text);
              return res ? res.label : null;
            } else if (editType === 'treeSelect') {
              return text && text.label ? text.label : text;
            } else if (editType === 'multiTreeSelect' && Array.isArray(text)) {
              const labels = text.map(v => v.label) || [];
              return labels;
            } else if (editType === 'checkbox' && Array.isArray(text)) {
              const filters = editOptions.filter(v => text.includes(v.value)).map(v => v.label) || [];
              return filters.length > 0 ? filters : text;
            } else {
              return text;
            }
          };
        }
        _columns.push({
          ...restOpts,
          title,
          dataIndex,
          width,
          editType,
          editOptions,
          editRules,
          ...(render ? { render } : {})
        });
      }
      if (operateFirst) {
        _columns.unshift(editColumn);
      } else {
        _columns.push(editColumn);
      }
    }
    _columns.forEach((v) => {
      if (v.editType) {
        v.editable = true;
      }
    });
    return _columns;
  }

  async componentDidMount() {
    const _columns = await this.caluNewColumns();
    this.setState({ newColumns: _columns });
  }

  async componentDidUpdate(_, preState) {
    const _columns = await this.caluNewColumns();
    if (!isEqual(this.state.columns, preState.columns) ||
      !isEqual(this.state.removeable, preState.removeable) ||
      !isEqual(this.state.upmoveable, preState.upmoveable) ||
      !isEqual(this.state.downmoveable, preState.downmoveable)) {
      this.setState({ newColumns: _columns });
    }
  }

  render() {
    const opts: any = {};
    const { editingKey, newColumns, dataSource } = this.state;
    const { footer, insertable, children,...restProps } = this.props;
    if (insertable) {
      opts.footer = (currentPageData) => (
        <React.Fragment>
          {footer && footer(currentPageData)}
          <a onClick={this.addRow}>
            <Icon type="plus" />
          </a>
        </React.Fragment>
      );
    }
    return (
      <Table
        {...opts}
        {...restProps}
        dataSource={dataSource}
        onSaveRowEdit={this.onSaveRowEdit}
        editRow
        columns={newColumns}
        editingKey={editingKey}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/table-edit/index.tsx